import { ContentSuggestionParams, SuggestionsType } from '../types';
import { useContentSuggestions } from './useContentSuggestions';
import { usePacks } from './usePacks';

export const useSuggestedPack = ({
    searchInput,
    showOnlyFilterSuggestions,
    hasActiveSearch,
}: {
    searchInput?: string;
    showOnlyFilterSuggestions: boolean;
    hasActiveSearch: boolean;
}) => {
    const { packs, isLoading, hasError } = usePacks();

    const suggestions = useContentSuggestions({
        contents: packs,
        isLoading,
        hasError,
        searchInput,
        showOnlyFilterSuggestions,
        hasActiveSearch,
        suggestionParams: ContentSuggestionParams.suggestedpacks,
        suggestionType: SuggestionsType.Pack,
    });

    return suggestions;
};
